import React from 'react';
import { createRef, lazy, useEffect, Suspense } from 'react';

import { observable, when } from 'mobx';
import { observer } from 'mobx-react';

class ObserverView {
  @observable state = false;
  element = null;
  constructor(element) {
    this.element = element;
  }
}

const interDivs = [];
const interObserver = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      const observerView = entry.isIntersecting && interDivs.find(obj => obj.element === entry.target);
      if (observerView) {
        observerView.state = true;
      }
    });
  },
  {
    // root: document.getElementById('root'),
    rootMargin: '0px',
    threshold: 0.25
  }
);
function delay(observerView) {
  return new Promise((resolve, reject) => {
    // setTimeout(resolve, ms);
    when(
      () => observerView.state,
      () => {
        resolve();
      }
    );
  });
}
export default function createLazyComponent(importPromiseFC) {
  const rootRef = createRef();
  const observerView = new ObserverView(rootRef.current);
  const LazyComponent = lazy(async () => {
    // await delay(observerView);
    return importPromiseFC();
  });
  return observer(({ ...props }) => {
    useEffect(() => {
      observerView.element = rootRef.current;
      interObserver.observe(rootRef.current);
      interDivs.push(observerView);
      return () => {
        observerView.state = false;
      };
    }, []);
    if (!observerView.state) {
      return <div ref={rootRef} style={{ height: '100vh', visibility: 'hidden' }} />;
    }
    /* return (
      <div ref={rootRef}>
        <Suspense fallback={<div style={{ height: '1200px' }} />}> 
          <LazyComponent {...props} />
        </Suspense>
      </div>
    );*/
    return (
      <Suspense fallback={<div style={{ height: '100vh' }} />}> 
        <LazyComponent {...props} />
      </Suspense>
    );
  });
}
